var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sponsors-column', { 'sponsors-two-col': _vm.isTwoColumn }]},_vm._l((_vm.sponsors),function(ref,i){
var company = ref.company;
var details = ref.details;
var id = ref.id;
return _c('div',{key:id,class:['sponsor-cell', ("tier-" + _vm.tierName), { 'sponsor-cell-full': _vm.isTwoColumn && _vm.sponsors.length % 2 !== 0 && i === _vm.sponsors.length - 1 }]},[_c('router-link',{staticClass:"company-logo-link",attrs:{"to":{
        name: 'companyProfile',
        params: { companyId: _vm.getId(company) },
      },"exact":""}},[_c('img',{class:['sponsor-img', ("sponsor-img-" + _vm.tierName)],attrs:{"src":details.logo,"alt":details.name || 'Sponsor logo'}})])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }